import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";

const AdminRegConfirm = () => {
  const location = useLocation();
  const [email, setEmail] = useState("");

  useEffect(() => {
    // Get email from the URL query parameter
    const queryParams = new URLSearchParams(location.search);
    const emailFromURL = queryParams.get('email');
    setEmail(emailFromURL); // Set email state
  }, [location]);

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="card p-4 text-center" style={{ maxWidth: "500px", width: "100%" }}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="50"
          viewBox="0 0 200.39 112.97"
          className="mx-auto mb-4"
        >
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <path d="M199.54,103.9l-60.27-101a6,6,0,0,0-8.87-1.64L2.3,102.26A6,6,0,0,0,6,113H28.33a6,6,0,0,0,3.72-1.29l91.24-71.9a6,6,0,0,1,8.86,1.64L154,78.06a6,6,0,0,1-5.16,9.08H121.13a6,6,0,0,0-3.69,1.26L99.68,102.24A6,6,0,0,0,103.37,113h91A6,6,0,0,0,199.54,103.9Z"></path>
            </g>
          </g>
        </svg>

        <h3 className="text-dark mb-3">Account Created Successfully!</h3>
        <p className="text-muted mb-4">
          Your account has been created successfully. A confirmation email has been sent to{" "}
          <strong>{email}</strong>.
        </p>

        <div className="mt-4">
          <Link to="/" className="btn btn-primary w-100">
            Go to Login Page
          </Link>
        </div>

        
      </div>
    </div>
  );
};

export default AdminRegConfirm;
